import TransportsConfig  from "./TransportsConfig";

export default TransportsConfig;